import _ from 'lodash'

import type { ModalPortalPayloadMap, ModalPayload } from '@app/types'
import type {
  InitializedModalPortals,
  ModalPortalHandlerInterface,
} from '../types'

import BaseModalHandler from './base-modal-handler'

export default class ModalCitizen
  extends BaseModalHandler
  implements ModalPortalHandlerInterface
{
  private initializedModalPortal: InitializedModalPortals

  constructor() {
    super()
    this.initializedModalPortal = {}
  }

  open<T extends keyof ModalPortalPayloadMap>(
    modalIdentifier: T,
    params?: ModalPayload<T>
  ): void {
    // Snapshot and clear the previously-open modal BEFORE emitting closed.
    // A listener of the closed event may call back into open/close, and
    // would otherwise see stale state and re-emit the same closed event.
    const previouslyOpen = Object.keys(
      this.initializedModalPortal
    ) as (keyof ModalPortalPayloadMap)[]
    this.initializedModalPortal = {
      [modalIdentifier]: modalIdentifier,
    }

    previouslyOpen.forEach((key) => {
      super._emitModalClosed(key)
    })

    this._emitModalOpened(modalIdentifier, params)
    this._addAppModalClass()
  }

  close<T extends keyof ModalPortalPayloadMap>(): T | null {
    if (_.isEmpty(this.initializedModalPortal)) {
      return null
    }

    const modalIdentifier = Object.keys(this.initializedModalPortal)[0] as T

    delete this.initializedModalPortal[modalIdentifier]
    this._removeAppModalClass()
    this._emitModalClosed(modalIdentifier)

    return modalIdentifier
  }

  hasOpenModal(): boolean {
    return !_.isEmpty(this.initializedModalPortal)
  }
}
